var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 479.19 503.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".m,.n{fill:#fff;}.n{stroke:#e2e2e1;}.n,.o,.p,.q,.r,.s,.t{stroke-miterlimit:10;}.o{fill:url(#g);}.o,.p,.r,.s{stroke:#84ad52;}.u{fill:url(#l);}.p{fill:url(#e);}.q{fill:url(#h);stroke:#84ad53;}.v{fill:url(#i);}.r{fill:url(#f);stroke-width:.25px;}.s{fill:url(#d);}.t{fill:#8fc15d;stroke:#315022;}.w{fill:url(#j);}.x{fill:url(#k);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 229.87,
    cy: 30.09,
    fx: 229.87,
    fy: 30.09,
    r: 19.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ec15d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8ec15c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#84ad52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 230.26,
    cy: 8.02,
    fx: 230.26,
    fy: 8.02,
    r: 21.24,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 237.16,
    cy: 11.76,
    fx: 237.16,
    fy: 11.76,
    r: 16.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ec15d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8ec15c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#72ad51"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 381.26,
    cy: 91.22,
    fx: 381.26,
    fy: 91.22,
    r: 25.93,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 228.98,
    cy: 250.4,
    fx: 228.98,
    fy: 250.4,
    r: 209.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ec15d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#8dbf5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84ad52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 228.98,
    cy: 250.4,
    fx: 228.98,
    fy: 250.4,
    r: 201.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f659a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3370a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d6091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cy: 250.4,
    fy: 250.4,
    r: 176.16,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 228.98,
    cy: 250.4,
    fx: 228.98,
    fy: 250.4,
    r: 169.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3370a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2f659a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d6091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 215.23,
    y1: 211.66,
    x2: 244.52,
    y2: 211.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dadada"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "s",
    points: "252.4 14.97 251.79 45.22 207.34 44.93 207.57 14.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 207.57,
    y1: 15.53,
    x2: 252.37,
    y2: 15.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    x: 201.18,
    y: 0.5,
    width: 58.17,
    height: 15.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.29,.65h-2.88c.92,10.34-6.94,19.02-16.92,19.25-10.34,.24-19.63-8.65-19.65-19.39h-2.9c.04,12.42,10.83,22.75,22.8,22.5,11.59-.24,20.69-10.32,19.54-22.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "387.84 116.81 407.54 96.35 407.11 96.76 373.8 66.07 374.21 65.63 354.98 86.15 387.84 116.81"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "q",
    cx: 228.98,
    cy: 250.4,
    r: 209.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "v",
    cx: 228.98,
    cy: 250.4,
    r: 201.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 228.98,
    cy: 250.4,
    r: 176.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "x",
    cx: 228.98,
    cy: 250.4,
    r: 169.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M236.84,236.68l-8.11-77.57-5.64,77.49c-4.67,2.45-7.85,7.33-7.85,12.97,0,8.09,6.56,14.65,14.65,14.65s14.65-6.56,14.65-14.65c0-5.57-3.11-10.41-7.68-12.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "95.17 13.22 110.16 4.09 118.12 40.88 95.17 13.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: ".78 85.6 10.15 72.95 29.12 100.35 .78 85.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "347.66 4.09 362.42 11.76 343.05 40.88 347.66 4.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "467.12 74.24 478.36 86.65 448.85 100.35 467.12 74.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: ".78 419.61 29.12 407.42 10.38 432.55 .78 419.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "95.17 492.45 115 465.06 107.87 502.28 95.17 492.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "350.18 502.28 343.05 469.26 362.42 491.74 350.18 502.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "467.82 432.55 448.85 407.42 478.36 419.98 467.82 432.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 302.92,
    cy: 76.87,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 228.98,
    cy: 62.61,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 158.77,
    cy: 74.24,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 107.87,
    cy: 395.55,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 350.18,
    cy: 395.55,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 107.87,
    cy: 105.87,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 350.18,
    cy: 105.87,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 68.05,
    cy: 352.23,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 413.52,
    cy: 204.53,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 228.98,
    cy: 439.35,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 158.77,
    cy: 425.41,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 302.92,
    cy: 424.27,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 68.05,
    cy: 150.46,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 389.04,
    cy: 150.46,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 387.89,
    cy: 352.23,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 414.67,
    cy: 283.15,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 43.39,
    cy: 283.15,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 43.39,
    cy: 211.66,
    r: 7.13
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeout);
export default __webpack_public_path__ + "static/media/timeout.d3ddb295ca9881db821d4cf5b3b2081a.svg";
export { ForwardRef as ReactComponent };